import React, { Suspense, useEffect } from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';

import { ChakraProvider } from '@chakra-ui/react';

import { system } from '$styles/chakra-theme';
import { BaseDataProvider } from '$context/base-data';
import ErrorBoundary from '$components/uhoh/fatal-error';
import { PageLoading } from '$components/page-loading';

export default function AppShell() {
  useEffect(() => {
    const banner = document.querySelector('#welcome-banner');
    if (banner) {
      banner.classList.add('dismissed');
      setTimeout(() => banner.remove(), 500);
    }
  }, []);

  return (
    <ChakraProvider value={system}>
      <ErrorBoundary>
        <BaseDataProvider>
          <ScrollRestoration />
          <Suspense fallback={<PageLoading />}>
            <Outlet />
          </Suspense>
        </BaseDataProvider>
      </ErrorBoundary>
    </ChakraProvider>
  );
}
